import { assets } from '@/ui/assets'
import { buttonVariants } from '@/ui/atoms/button/Button'
import { InternalLink } from '@/ui/atoms/link/Link'
import { cn } from '@/ui/utils/style'

export function TopbarPoints() {
  const className = cn(buttonVariants({ variant: 'tertiary', size: 'm', spacing: 's' }), 'gap-1')
  return (
    <InternalLink
      variant="unstyled"
      to="/points/{-$referralCode}"
      className={className}
      activeProps={{ className: cn(className, 'border-page-spark-token!') }}
    >
      <img src={assets.points.pointsIcon} alt="Points icon" className="icon-size-sm shrink-0" />
      <span className="top-bar-xl:block hidden">Points</span>
    </InternalLink>
  )
}
